import axios from 'axios'
import ApiErrors from '../utilities/ApiErrors';

export default {

    async get(opciones = {}) {

        const pagina = opciones.page ?? 0;
        const cantidad = opciones.rows ?? 5000;
        const sort_nombre = opciones.sortField ?? 'id';
        const sort_orden = opciones.sortOrder ?? 1;
        const filtro = opciones.filters?.global?.value ?? '';
        const borrados = opciones.borrados ?? false;

        try {
            const { data } = await axios({ url: `/tyc/?pagina=${pagina}&cantidad=${cantidad}&sort_nombre=${sort_nombre}&sort_orden=${sort_orden}&filtro=${filtro}&borrados=${borrados}`, method: 'GET' })
            return data;
        } catch (error) {
            return ApiErrors.handleErrors(error);
        }

    },

    async getUltimo() {

        try {
            const { data } = await axios({ url: `/tycultimo/`, method: 'GET' })
            return data;
        } catch (error) {
            return ApiErrors.handleErrors(error);
        }

    },

    async add(tycNuevo) {

        try {
            const { data } = await axios({ url: `/tyc/`, data: tycNuevo, method: 'POST' })
            return data;
        } catch (error) {
            return ApiErrors.handleErrors(error);
        }

    },

    async update(tycActualizado) {

        try {
            const { data } = await axios({ url: `/tyc/${tycActualizado.id}`, data: tycActualizado, method: 'PUT' })
            return data;
        } catch (error) {
            return ApiErrors.handleErrors(error);
        }

    },

    async delete(tycId) {

        try {
            await axios({ url: `/tyc/${tycId}`, method: 'DELETE' })
        } catch (error) {
            return ApiErrors.handleErrors(error);
        }

    },
}
